// @flow

import { isDefined } from 'util/ObjectUtils';

export const isNotEmptyOdooField = (value: string) => {
  return isDefined(value) && value !== 'false';
};
